import React, { memo } from 'react';
import { Link } from 'react-router-dom';

import images from 'assets/images';
import { LOCATIONS } from 'constants/index';

import SidebarContent from './SidebarContent';

const Sidebar = () => (
  <div className="vertical-menu position-fixed">
    <div className="navbar-brand-box">
      <Link to={LOCATIONS.HOME_PAGE} className="logo logo-dark">
        <span className="logo-sm">
          <img src={images.logoBookeseMini.default} alt="" height="30" />
        </span>

        <span className="logo-lg">
          <img src={images.logoBookeseFull.default} alt="" height="30" />
        </span>
      </Link>

      <Link to={LOCATIONS.HOME_PAGE} className="logo logo-light">
        <span className="logo-sm">
          <img src={images.logoBookeseMini.default} alt="" height="30" />
        </span>

        <span className="logo-lg">
          <img src={images.logoBookeseFull.default} alt="" height="30" />
        </span>
      </Link>
    </div>

    <div data-simplebar className="h-100">
      <SidebarContent />
    </div>
    <div className="sidebar-background" />
  </div>
);

export default memo(Sidebar);
